import { Link } from 'react-router-dom';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <p>Limited Spots Available</p>
      <h3>Register today & start exploring endless learning possibilities.</h3>
    </div>
    <div className="gpt3__cta-btn">
      <Link to="/contact">
        <button type="button">Get Started</button>
      </Link>
    </div>
  </div>
);

export default CTA;